import { USERS_QUERY } from 'src/graphql/user/query';

// eslint-disable-next-line import/prefer-default-export
export const REFETCH_USERS_LIST_QUERIES = [
  {
    query: USERS_QUERY,
    variables: {
      limit: 1000,
      offset: 0,
    },
  },
];
